module.exports = __webpack_public_path__ + "static/img/info.32c53617.svg";